import Util from "@/Master/Util";

declare global {
    interface Window {
        isLog?: boolean;
    }
}

interface EmailData {
    email: string;
    subject: string;
    body: string;
}

interface DialogData {
    url: string;
    title: string;
}

type CallbackFunction = () => void;

export default class SdkMgr {
    static Init(): void {

    }

    /**
     * 发送邮件（附带主题内容）
     * @param data 示例{"email":"123456@qq.com","subject":"123456","body":"123456"}
     */
    static jumpEmail(data: EmailData): void {
        const email = data.email;
        const subject = data.subject;
        const body = data.body;
        window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    }

    /**
     * 打开支付页面
     * 用iframe跳转
     * @param url 链接
     * @param sessionID 会话ID
     * @param onloadCallback iframe加载完成后的回调
     */
    static jumpPay(url: string, sessionID: string, onloadCallback: CallbackFunction): void {
        if (window.isLog) {
            console.log('jumpPay');
        }
        // this.addIframeDialog(url, onloadCallback);
        // this.iframe.style.display = 'block';
        // // this.SendUpdateDataMsg();
    }

    /**
     * 跳转链接
     * @param url 链接
     * @param mode 打开方式 0： 原地跳转 1： 新页面打开链接  2：用内嵌iframe打开
     * @param onCallback 回调函数
     */
    static openUrl(url: string, mode: number = 1, onCallback: CallbackFunction | null = null): Window | null | void {
        console.log('jumpUrl');
        const HREF = 0;
        const OPEN = 1;
        const IFRAME = 2;
        switch (mode) {
            case HREF:
                location.href = url;
                break;
            case OPEN:
                let newWindow: Window | null = null;
                if (Util.isLog) {
                    setTimeout(() => {
                        newWindow = window.open(url, '_blank');
                    }, 100);
                } else {
                    newWindow = window.open(url, '_blank');
                    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                        // 如果浏览器阻止了弹窗，你可以使用当前窗口打开页面
                        window.location.href = url;
                    }
                }
                return newWindow;
            case IFRAME:
                const json: DialogData = JSON.parse(url);
                // DialogMgr.ShowDialog(json.url, json.title, onCallback);
                // this.ShowIframeDialog(json.url, json.title, onCallback);
                // this.iframe.style.display = 'block';
                // this.iframeBar.style.display = 'block';
                break;
            default:
                location.href = url;
                break;
        }
    }
}
